<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.audit_withdrawal") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12
                .d-inline-block
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.refresh') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="$options.refreshOn" @change="toggleRefresh()")
                        span.custom-switch-indicator
                    b-input-group-text(slot="append")
                      b-input(v-model="refreshInterval" type="range" min="1" max="5")
                    b-input-group-text(slot="append")
                      span {{ refreshInterval }} s
              .form-group.col-3
                b-input-group(size="sm")
                  b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                    option(value="operator" v-if="!isOperator") {{ $t('ui.operator') }}
                    option(value="member" v-else-if="isOperator") {{ $t('ui.member') }}
                    option(value="ticket") {{ $t('ui.ticket') }}
                  template(v-if="['operator'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="operatorID" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                  template(v-else-if="['member'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" @enter="getTicketList()" size="sm")
                  template(v-if="['ticket'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
              template(v-if="['operator'].includes(searchType)")
                .form-group.col-3(v-if="operatorID != ''")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
              .form-group.col-12
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList()"
                  variant="primary"
                  size="sm"
                )

          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              .col-md-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="5%")
                          span(:title="$t('ui.id')") {{ $t('ui.id') }}
                        th(width="8%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.affiliate')") {{ $t('ui.affiliate') }}
                          .float-right 
                            i(:class="changeSortKey('account_id')")
                        th.text-right(width="7%" @click="sortOrder('amount')")
                          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                          .float-right 
                            i(:class="changeSortKey('amount')")
                        th(width="17%")
                          span(:title="$t('ui.recipient_bank')") {{ $t('ui.recipient_bank') }}
                        th.text-center(width="6%" @click="sortOrder('status')")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                          .float-right 
                            i(:class="changeSortKey('status')")
                        th.text-center(width="8%")
                          span(:title="$t('ui.rollback_count')") {{ $t("ui.rollback_count") }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.rejected_ticket_id')") {{ $t("ui.rejected_ticket_id") }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th.text-right(width="10%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right 
                            i(:class="changeSortKey('created_date')")
                    tbody.clusterize-content
                      tr(v-if="withdrawalList.length == 0")
                        td(:colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in withdrawalList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.id") {{ item.id }}
                        td
                          span.d-block(:title="item.account_id") {{ item.account_id }}
                          span.text-warning(:title="item.operator_id") {{ item.operator_id }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                        td
                          span(:title="item.recipient_bank_id") {{ item.recipient_bank_id }}
                          br
                          span(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}
                          br
                          span(:title="item.recipient_bank_acc_holder") {{ item.recipient_bank_acc_holder }}
                          template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                            br
                            span(:title="item.recipient_bank_acc_remark") {{ item.recipient_bank_acc_remark }}
                          template(v-if="['AUD'].includes(getCurrencyCode)")
                            br
                            span(:title="item.recipient_bank_acc_remark_2") {{ item.recipient_bank_acc_remark_2 }}
                        td.text-center
                          span.font-weight-bold(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                        td.text-center
                          span.font-weight-bold(:title="$n(item.rollback_count, 'integer')" v-if="item.rollback_count")
                            b-link.clickable(href="javascript:void(0);" @click="onGetRollbackDetail(item)") {{ $n(item.rollback_count, 'integer') }}
                          span(v-else) {{ item.rollback_count }}
                        td.text-center
                          span.font-weight-bold(:title="item.rejected_ticket_id" v-if="item.rejected_ticket_id")
                            b-link.clickable(href="javascript:void(0);" @click="onGetRejectDetail(item)") {{ item.rejected_ticket_id }}
                          span(v-else) {{ item.rejected_ticket_id }}
                        td.text-center
                          span
                            a.fa.fa-search.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                          template(v-if="isEditAccess")
                            span.ml-1(v-if="item.status.trim().toUpperCase() == 'REVIEW'")
                              a.fa.fa-check-double.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="auditTicket(item, $event)" :title="$t('ui.audit')")
                            span.ml-1
                              a.fa.fa-check.btn.btn-ssm.btn-success(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.approve')")
                            span.ml-1
                              a.fas.fa-check-circle.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="manualApproveAffiliate(item, $event)" :title="$t('ui.manual_approve')")
                            span.ml-1
                              a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                        td.text-right
                          span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    ticketdetailaffiliate(ref="ticketdetailaffiliate" :ticketDetail="selectedTicket" @failed="handleFailed")
    rejectticketaffiliate(ref="rejectticketaffiliate" :ticketDetail="selectedTicket" @clicked="afterRejectTicket" @failed="handleFailed")
    auditticketaffiliate(ref="auditticketaffiliate" :ticketId="selectedTicketId" @clicked="afterAuditTicket" @failed="handleFailed")
    approveticketaffiliate(ref="approveticketaffiliate" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterApproveTicket" @failed="handleFailed")
    manualapproveaffiliate(ref="manualapproveaffiliate" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterManualTicket" @failed="handleFailed")

    getrollbackdetail(ref="getrollbackdetail" :item="selectedTicket" @failed="handleFailed")
    getrejectdetail(ref="getrejectdetail" :item="selectedTicket" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import rejectticketaffiliate from "@/components/affiliate/rejectTicketAffiliate.vue";
import ticketdetailaffiliate from "@/components/affiliate/ticketDetailAffiliate.vue";
import auditticketaffiliate from "@/components/affiliate/auditTicketAffiliate.vue";
import approveticketaffiliate from "@/components/affiliate/approveTicketAffiliate.vue";
import manualapproveaffiliate from "@/components/affiliate/manualApproveAffiliate.vue";
import getrollbackdetail from "@/components/affiliate/getRollbackDetail.vue";
import getrejectdetail from "@/components/affiliate/getRejectDetail.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    rejectticketaffiliate,
    ticketdetailaffiliate,
    auditticketaffiliate,
    approveticketaffiliate,
    manualapproveaffiliate,
    getrollbackdetail,
    getrejectdetail,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    withdrawalList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    ticketTimer: null,
    refreshInterval: 5,
    refreshChange: "",
    sortKey: "id",
    sortType: "desc",
    ticketId: "",
    ticketStatus: "AUDIT",
    searchType: "ticket",
    operatorID: "",
    memberID: "",
    selectedTicket: null,
    selectedTicketId: null,
    selectedParentId: null,
    selectedMemberId: null,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_ticketlistreviewauditaffiliate");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  created: function() {
    this.$options.refreshOn = false;
  },
  mounted: function() {
    this.getTicketList();
  },
  destroyed: function() {
    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    }
  },
  methods: {
    resetInput() {
      this.operatorID = "";
      this.memberID = "";
      this.ticketStatus = "AUDIT";
      this.ticketId = "";
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getWithdrawalList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onGetRollbackDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrollbackdetail.$refs.getRollbackDetail.show();
    },
    onGetRejectDetail(e) {
      this.selectedTicket = e;
      this.$refs.getrejectdetail.$refs.getRejectDetail.show();
    },
    getTicketDetail: function(e) {
      this.selectedTicket = e;
      this.$refs.ticketdetailaffiliate.$refs.ticketDetailAffiliate.show();
    },
    getTicketList() {
      this.getWithdrawalList(true);
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListReviewAuditAffUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId == "" ? null : this.ticketId,
        ticket_status: this.ticketStatus,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.operator_id = this.operatorID
        json.account_id = this.memberID
      } else {
        json.ticket_id = this.ticketId
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.totalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    manualApproveAffiliate: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.operator_id;
      this.selectedMemberId = e.account_id;
      this.$refs.manualapproveaffiliate.$refs.manualApproveAffiliate.show();
    },
    rejectTicket: function(e) {
      this.selectedTicket = e;
      this.$refs.rejectticketaffiliate.$refs.rejectTicketAffiliate.show();
    },
    auditTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.auditticketaffiliate.$refs.auditTicketAffiliate.show();
    },
    approveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.operator_id;
      this.selectedMemberId = e.account_id;
      this.$refs.approveticketaffiliate.$refs.approveTicketAffiliate.show();
    },
    afterRejectTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.reject_affiliate_ticket"), this.$t("message.success"), "success");
    },
    afterApproveTicket: function(type, afterBalance) {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.approve_affiliate_ticket"), this.$t("message.success"), "success");
    },
    afterAuditTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.audit_affiliate_ticket"), this.$t("message.success"), "success");
    },
    afterManualTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.approve_affiliate_ticket"), this.$t("message.success"), "success");
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.$options.refreshOn) {
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getWithdrawalList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getWithdrawalList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>